import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

// Centralized toast configuration and helper used across the app
export function configureToastr() {
  try {
    // avoid re-configuring multiple times
    if (typeof window !== 'undefined' && window.__keyquest_toastr_configured) return

    toastr.options = {
      positionClass: 'toast-bottom-right',
      timeOut: 5000,
      extendedTimeOut: 1000,
      closeButton: true,
      progressBar: true,
      preventDuplicates: true,
      newestOnTop: true,
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
      showDuration: 300,
      hideDuration: 1000,
    }

    // Inject the project's toast CSS once (keeps login/app styles consistent)
    try {
      if (typeof document !== 'undefined' && !document.getElementById('keyquest-toast-styles')) {
        const s = document.createElement('style')
        s.id = 'keyquest-toast-styles'
        s.innerHTML = `
          /* Base toast styling - brighter pink-tinged dark for stronger highlight */
          #toast-container > .toast { background-color: #3b1024 !important; color: #fff !important; border: 1px solid #5a2033 !important; box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35) !important; position: relative; overflow: hidden; }

          /* Wider gradient left-accent for stronger highlight */
          #toast-container > .toast::before { content: ""; position: absolute; left: 0; top: 0; bottom: 0; width: 12px; background: linear-gradient(180deg, rgba(246,37,90,1), rgba(255,120,150,0.95)); }
          #toast-container > .toast-success::before { background: linear-gradient(180deg, #28a745, #3deb8a); }
          #toast-container > .toast-error::before { background: linear-gradient(180deg, #dc3545, #ff6b7f); }
          #toast-container > .toast-info::before { background: linear-gradient(180deg, #F6255A, #FF6B8A); }
          #toast-container > .toast-warning::before { background: linear-gradient(180deg, #ffc107, #ffd36b); }

          /* Stronger colored glow to make highlight more visible */
          #toast-container > .toast-success { box-shadow: 0 12px 40px rgba(40,167,69,0.14) !important; }
          #toast-container > .toast-error { box-shadow: 0 12px 40px rgba(220,53,69,0.14) !important; }
          #toast-container > .toast-info { box-shadow: 0 12px 40px rgba(246,37,90,0.18) !important; }
          #toast-container > .toast-warning { box-shadow: 0 12px 40px rgba(255,193,7,0.14) !important; }

          /* Keep close button visible */
          .toast-close-button { color: #fff !important; opacity: 1 !important; }
          .toast-close-button:hover { opacity: 1 !important; }
        `
        document.head.appendChild(s)
      }
    } catch (err) {
      // ignore
    }

    if (typeof window !== 'undefined') window.__keyquest_toastr_configured = true
  } catch (err) {
    // ignore
    // eslint-disable-next-line no-console
    console.warn('configureToastr error', err)
  }
}

export function triggerToast(msg, type = 'info', title = '') {
  try {
    if (type === 'success') return toastr.success(msg, title)
    if (type === 'error') return toastr.error(msg, title)
    if (type === 'warning') return toastr.warning(msg, title)
    return toastr.info(msg, title)
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('triggerToast error', err)
    return null
  }
}
